"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const component_1 = require("@festival/component");
const react_mobx_store_container_1 = require("react-mobx-store-container");
const image_header_1 = require("@festival/page-configuration/image-header");
const list_1 = require("@festival/actuality/list");
const store_factory_1 = require("@festival/actuality/store-factory");
class Home extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.pageConfigurationStore) {
            this.props.pageConfigurationStore.setCurrent('home');
        }
    }
    render() {
        return (React.createElement(component_1.DynamicModule, { name: "home", extensions: this.extensions },
            React.createElement(react_mobx_store_container_1.DynamicProvider, { names: [store_factory_1.factory] }, this.renderContent())));
    }
    renderContent() {
        return (React.createElement(React.Fragment, null,
            React.createElement(image_header_1.default, null),
            React.createElement(list_1.default, null)));
    }
    get extensions() {
        return [];
    }
}
exports.Home = Home;
exports.default = mobx_react_1.inject('pageConfigurationStore')(mobx_react_1.observer(Home));
